import React from "react";
import {FormControlLabel, Radio, RadioGroup} from "@material-ui/core";
import './index.scss';
import radioCheckedIcon from "../../../images/radio_checked.svg";
import radioUnCheckedIcon from "../../../images/radio_unchecked.svg";
import {ReactSVG} from "react-svg";

interface Props {
    idPrefix?: string;
    value: any;
    options: any[]
    getLabel: (val: any) => string;
    onChangeListener: (val: any) => void;
}

export const SelectOneRadioOld = ({value, options, onChangeListener, getLabel, idPrefix}: Props) => {
    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChangeListener(event.target.value);
    };

    const isIos = /\((iPhone|iPad);/.test(window.navigator.userAgent)

    return (
        <div className='select-one-radio'>
            <RadioGroup row={true} className={'select-one-radio-group'} value={value} onChange={onChange}>
                {options.map((val, index) => {
                    return <FormControlLabel id={idPrefix + '_' + index}
                        value={val}
                        key={idPrefix + '_' + index}
                        className={`select-one-radio-control-label ${val === value ? 'active' : 'inactive'}`}
                        control={
                            <Radio className='select-one-radio-item'
                                icon={  isIos
                                    ? <object className="select-one-radio_ios_costyl" data={radioUnCheckedIcon} type="image/svg+xml"></object>
                                    : <ReactSVG src={radioUnCheckedIcon}/>
                                }
                                checkedIcon={ isIos
                                    ? <object className="select-one-radio_ios_costyl" data={radioCheckedIcon} type="image/svg+xml"></object>
                                    : <ReactSVG src={radioCheckedIcon}/>
                                } />
                        }
                        label={getLabel(val)}/>
                })}
            </RadioGroup>
        </div>
    )
};